import { selectWidgetsWithChat } from 'ducks/widgets/selectors'
import { CHAT_PAGE } from 'subapps/chat/pages'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import { selectRoomIdFromUrl } from 'ducks/chat/selectors/rooms'
import {
  queryIdToQuery,
  defaultFolderItemQueryId,
} from 'ducks/searches/utils/query'
import { queryParams } from 'util/params'
import {
  BUILD_FROM_WIDGETS,
  TOGGLE_COLLECTION,
  OPEN_ONE_COLLECTION,
} from '../actionTypes/collections'
import { selectFolders } from '../selectors/folders'

export function doToggleCollection({ collectionId, event }) {
  return dispatch => {
    if (queryParams().channelId === collectionId) {
      event.preventDefault()
    }
    return dispatch({
      type: TOGGLE_COLLECTION,
      payload: {
        collectionId,
      },
    })
  }
}

export function doOpenOneCollection({ collectionId, event }) {
  return dispatch => {
    if (queryParams().channelId === collectionId) {
      event.preventDefault()
    }
    return dispatch({
      type: OPEN_ONE_COLLECTION,
      payload: {
        collectionId,
      },
    })
  }
}

export function doBuildMenuFromWidgets({ autoRedirect = true } = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const widgets = selectWidgetsWithChat(state)
    const folders = selectFolders(state)
    const currentQueryId = selectCurrentQueryId(state)
    dispatch({
      type: BUILD_FROM_WIDGETS,
      payload: {
        widgets,
        folders,
      },
    })
    // Kevin R: I would have preferred dispatching BUILD_FROM_WIDGETS
    // and the doRedirectToDefaultCollectionAndFolder in a batch action
    // but for some reason the redux first router doesnt play well with
    // out batching system
    if (!currentQueryId && autoRedirect) {
      dispatch(doRedirectToDefaultCollectionAndFolder())
    }
  }
}

export function doRedirectToDefaultCollectionAndFolder() {
  return (dispatch, getState) => {
    const state = getState()
    const widgets = selectWidgetsWithChat(state)
    const folders = selectFolders(state)

    if (widgets.length === 0 || folders.length === 0) return
    const query = queryIdToQuery(defaultFolderItemQueryId({ widgets, folders }))
    const conversationId = selectRoomIdFromUrl(state)
    if (conversationId) {
      query.conversationId = conversationId
    }
    dispatch({
      type: CHAT_PAGE,
      payload: {},
      meta: {
        query,
      },
    })
  }
}
